import { render, staticRenderFns } from "./ActivityTabHistory.vue?vue&type=template&id=5028750b&"
import script from "./ActivityTabHistory.vue?vue&type=script&lang=js&"
export * from "./ActivityTabHistory.vue?vue&type=script&lang=js&"
import style0 from "./ActivityTabHistory.vue?vue&type=style&index=0&id=5028750b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports